import { useCallback, useMemo } from 'react'
import { GitCompare } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchConfigHistory, DT_STR as S, type ConfigChangeRow } from './devtoolsApi'

/**
 * A27.13 — Diff конфигурации. Config change log (key old→new + who/when) — the
 * diff viewer. Wired to the real `/admin/config/history` (fail-soft to empty
 * until it ships). Placeholder permission USERS_VIEW.
 */
export function ConfigDiffScreen() {
  const columns = useMemo<AdminColumn<ConfigChangeRow>[]>(
    () => [
      { key: 'key', header: S.key, type: 'text' },
      { key: 'old_value', header: S.oldValue, type: 'longtext' },
      { key: 'new_value', header: S.newValue, type: 'longtext' },
      { key: 'changed_by', header: S.changedBy, type: 'text' },
      { key: 'changed_at', header: S.changedAt, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchConfigHistory, [])
  return (
    <>
      <PageHeader title={S.configDiff} screenId="A27.13" />
      <DataTable<ConfigChangeRow>
        screenId="A27.13"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <GitCompare size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
